module.exports = __webpack_public_path__ + "img/tarjeta_servicios_asistencia_hogar.5468db24.jpg";